import { MutationTree } from "vuex";
import { RouteState } from "./index";
import { RouteLocationNormalized } from "vue-router";

export enum RouteMutation {
    SetPreviousRoute = "SetPreviousRoute"
}

const mutations: MutationTree<RouteState> = {
    [RouteMutation.SetPreviousRoute](state, payload: RouteLocationNormalized) {
        state.previousRoute = payload;
    }
};

export default mutations;
